import {eventLogType, IincidentReportList} from './model'

export const filterOnlyIncidentType = (eventLog: eventLogType) =>
  eventLog['Event Type']?.toLowerCase() === 'incident'

export const convertExcelDataToTableAndCharts = (data: eventLogType[]) => {
  const incidentFilteredData = data.filter(filterOnlyIncidentType)
  let tableMapData = new Map<string, IincidentReportList>()
  let chartMapData = new Map<string, {event: string; count: number}>()
  incidentFilteredData.forEach((item) => {
    const eventDetail = item['Event Details']
    const checkPoint = item['Check Point']
    if (!eventDetail) return
    const key = `${eventDetail}-${checkPoint}`
    const chartKey = eventDetail
    const prevCount = tableMapData.has(key) ? tableMapData.get(key)?.noOfEvents || 0 : 0
    const currentCount = prevCount + 1
    const prevChartCount = chartMapData.has(chartKey) ? chartMapData.get(chartKey)?.count || 0 : 0
    const currentChartCount = prevChartCount + 1
    tableMapData.set(key, {checkpoints: checkPoint, events: eventDetail, noOfEvents: currentCount})
    chartMapData.set(chartKey, {count: currentChartCount, event: eventDetail})
  })
  return {tableMapData, chartMapData}
}
